<template>
    <div class="user-popup" :class="{ 'user-popup--opened': showPopup }">
        <form method="post" action="/" ref="form" @submit.prevent="loginFormSubmit">
            <div class="alert alert-danger mb-3" v-if="isLoginIncorrect">
                {{ dictionary.siteHeader.login.incorrectLogin }}
            </div>

            <label for="user-popup-form-email">{{ dictionary.siteHeader.login.email }}</label>
            <input
                id="user-popup-form-email"
                class="user-popup__text-input"
                v-model="email"
                name="email"
                type="email"
                required
                autocomplete="off"
                @click.prevent="openUserMenu"
            />
            <input type="hidden" name="redirect_uri" :value="redirectUriAll" />
            <label for="user-popup-form-password">{{ dictionary.siteHeader.login.password }}</label>
            <div class="position-relative">
                <input
                    id="user-popup-form-password"
                    class="user-popup__text-input"
                    name="password"
                    v-model="password"
                    :type="passwordType"
                    @click.prevent="openUserMenu"
                    required
                />
            </div>

            <a :href="dictionary.url.user.forgottenPassword" class="user-popup__forgotten-password fs-14" rel="nofollow">
                {{ dictionary.siteHeader.login.sendForgottenPassword }}
            </a>

            <button data-cy="submitUserLogin" v-if="isPwa" type="submit" class="btn btn-primary w-100 mt-2 rounded-pill py-2 fs-14">
                {{ dictionary.siteHeader.login.loginAction }}
            </button>

            <input
                v-else
                type="submit"
                :value="dictionary.siteHeader.login.loginAction"
                class="btn btn-primary w-100 mt-2 rounded-pill py-2 fs-14"
            />

            <a :href="'/social-login/google?redirect_uri=' + redirectUri" class="login-google" data-method="Google" rel="nofollow">
                <i class="ico ico--login-google mr-2"></i>
                <span>{{ dictionary.siteHeader.login.google }}</span>
            </a>

            <a
                :href="dictionary.url.user.registration"
                data-cy="goToRegistration"
                class="btn btn-outline-primary w-100 mt-2 rounded-pill py-2"
                >{{ dictionary.siteHeader.login.register }}</a
            >
        </form>
    </div>
</template>

<script>
export default {
    props: {
        isPwa: {
            type: Boolean,
            required: true,
        },
        dictionary: {
            type: Object,
            required: true,
        },
        showPopup: {
            type: Boolean,
            default: false,
        },
        uid: {
            type: String,
            required: true,
        },
        baseUrl: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            isLoginIncorrect: false,
            passwordType: 'password',
            email: '',
            password: '',
            redirectUri: '',
            redirectUriAll: '',
        }
    },
    mounted() {
        this.redirectUriUpdate()
    },
    methods: {
        openUserMenu() {
            document.body.classList.add('user--open')
        },

        redirectUriUpdate() {
            if (typeof window !== 'undefined') {
                this.redirectUri = window.location.pathname
                this.redirectUriAll = window.location.href
            }
        },

        async loginFormSubmit() {
            const url = `${this.baseUrl}/api/v3/login`
            const inputData = {
                email: this.email,
                password: this.password,
                uid: this.uid,
            }
            const headers = {
                platform: 'pwa',
            }

            let loginResponse = {}
            if (this.isPwa) {
                // eslint-disable-next-line
                loginResponse = await $fetch(url, {
                    method: 'POST',
                    headers,
                    body: inputData,
                })
            } else {
                loginResponse = await fetch(url, { method: 'post', body: inputData })
                loginResponse = await loginResponse.json()
            }

            if (loginResponse.result) {
                if (loginResponse.response.verificationMethod === 'none') {
                    this.$emit('logged', loginResponse.response.data)

                    return
                }

                window.location = '/login-verify?attemptId=' + loginResponse.response.data.attemptId
            } else {
                this.isLoginIncorrect = true
            }
        },
    },
}
</script>

<style lang="scss">
$white: #fff;

.alert-danger {
    border: 0;
    background: #e65353;
    color: $white;
    padding: 1rem;
    border-radius: 4px;
}

.user-popup {
    padding: 1rem;
    position: absolute;
    top: 100%;
    right: 0;
    margin-top: -1px;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 0 12px rgba(0, 0, 0, 0.1);
    width: 300px;

    .login-google {
        display: flex;
        justify-content: center;
        gap: 10px;
        font-size: 14px;
        border-radius: 50px;
        color: #333;
        text-align: center;
        border: 1px solid #333;
        padding: 8px;
        margin: 10px 0 5px;
        width: 100%;

        &:hover {
            @media (min-width: 768px) {
                background-color: #f6f6f6;
            }
        }
    }

    &--open {
        display: block;

        @media (hover: none) {
            display: none;
        }
    }

    label {
        font-size: 12px;
        margin: 0;
    }

    &__text-input {
        border-radius: 10px;
        display: block;
        width: 100%;
        line-height: 35px;
        padding: 0 15px;
        font-size: 16.1px;
        background-color: #f6f6f6;
        border: 1px solid #cbd5e1;
        margin-bottom: 10px;
        margin-top: 2px;

        @media (min-width: 890px) {
            font-size: 14px;
        }

        &:active,
        &:-webkit-autofill,
        &:focus,
        &:-webkit-autofill,
        &:hover {
            background-color: #f6f6f6;
            -webkit-box-shadow: 0 0 0 1000px #f6f6f6 inset;
        }
    }

    &__show-password {
        position: absolute;
        right: 10px;
        top: 0;
        background: none;
        border: 0;
        line-height: 35px;
        padding: 0;
    }

    &__forgotten-password {
        // TODO: resolve this shit later
        color: #696969 !important;
        text-decoration: none;
        display: block !important;
        padding: 0 !important;
        margin-bottom: 0 !important;

        &:hover {
            text-decoration: underline;
        }
    }
}

.btn.btn-facebook {
    background-color: #3b5998;
    color: #fff;
    display: flex;
    justify-content: center;

    &:hover {
        background-color: darken(#3b5998, 5%);
        color: #fff;
    }
}

.btn.btn-google {
    background-color: #fff;
    color: #333333;
    border-color: #696969;
    display: flex;
    justify-content: center;

    &:hover {
        background-color: darken($white, 5%);
    }
}
</style>
